import { Component, OnInit, OnDestroy, OnChanges, ChangeDetectorRef, ChangeDetectionStrategy, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { Subscription, fromEvent } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { map, startWith } from 'rxjs/operators';
import { MatSelectionList } from '@angular/material/list';
import { ApploadServiceService } from '../services/appload-service.service';
import { UserService } from '.././services/user.service';
import { kill } from 'process';
import { SELECT_PANEL_INDENT_PADDING_X } from '@angular/material';
import { WizardHpBaseComponent } from '../base/wizard/wizard-hp-base-component';
import { HpService } from '../services/hp.service';
import { SimulateurComponent } from '../simulateur/simulateur.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { HomeComponent } from '../home/home.component';
export interface Porte {
  id: number;
  keywords: string;
  name: string;
  image: string;
  qst_id: any;
}

@Component({
  selector: 'app-familles',
  templateUrl: './familles.component.html',
  styleUrls: ['./familles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FamillesComponent extends WizardHpBaseComponent implements OnInit {
  public productData: any;
  famId: any;
  constructor(chgDetectorRef: ChangeDetectorRef, private userService: UserService,
    hpService: HpService,
    router: Router,
    private deviceService: DeviceDetectorService,
    private location: Location) {
      super(chgDetectorRef, hpService, router);

    this.productData = this.getHpService().getDataFamilles();
    this.getHpService().setCurrentPage(this.getIndexNextUrl('familles'));

    if (this.productData && this.productData.root && this.productData.root.data
          && this.productData.root.data.length == 1) {
      var fam = this.productData.root.data[0];
      this.getFamilles(fam.id, fam.leaf);
    }
  }

  ngOnChanges() {

  }
  ngOnInit() {

    super.ngOnInit();


  }

  public getFamilles(famId: any, leaf: boolean) {
    if (leaf) {
      this.getHpService().fetchProducts(this.getHpService().getCatId(), famId).subscribe(data => {
        this.getHpService().setListProducts(data);
        this.famId = encodeURIComponent(data.root.data[0].id);
        this.getHpService().setParameters(famId);
        this.getHpService().setListProducts(data);
        this.productData = data;
        this.getHpService().setPanneaux(data)
        this.getHpService().emitDataChange();
        this.getHpService().setCurrentPage(this.getIndexNextUrl('liste-produits'))
        this.getRouter().navigate(['liste-produits']);
      });
      return;
    }
    
    this.getHpService().fetchFamilles(this.getHpService().getCatId(), famId).subscribe(data => {

      if (data.root.data[0].leaf && data.root.data.length === 1) {
        var id = encodeURIComponent(data.root.data[0].id);
        let params_ = this.getHpService().getParameters() + "/" + id;
      this.getHpService().fetchProducts(this.getHpService().getCatId(), params_).subscribe(data => {
          this.getHpService().setListProducts(data);
          this.famId = encodeURIComponent(data.root.data[0].id);
          this.getHpService().setParameters(this.famId);
          this.productData = data;
          this.getHpService().setPanneaux(data)
          this.getHpService().emitDataChange();
          this.getHpService().setCurrentPage(this.getIndexNextUrl('liste-produits'))
          this.getRouter().navigate(['liste-produits']);
        });
        return;
      }
      this.getHpService().setDataSousFamilles(data)
      this.famId = famId;
      this.getHpService().setParameters(famId);
      this.getHpService().emitDataChange();
      this.getHpService().setCurrentPage(this.getIndexNextUrl('liste-produits'))
      this.getRouter().navigate(['sous-familles']);
    })

  }
}
